export default {
  name: 'Dynamic menu |||| Dynamic menus',
  subtitle: 'Here you can manage the dynamic menus of the system',
  list: {
    id: 'ID',
    name: 'Name',
    code: 'Code',
    mappings: 'Mappings',
    back: 'Back to menu',
    channel: 'Channel',
    solution: 'Solution',
    dynamicMenu: 'Dynamic menu',
    any: 'Any',
    noResultsFound: 'No results found',
    searchInProgress: 'Search is in progress...',
    findItem: 'Find item',
    itemId: 'Item ID',
    find: 'Find',
    itemUpdatedSuccessfully: 'Menu item updated successfully',
  },
  show: {
    id: 'ID',
    detailsHeading: 'Menu details',
    recordTitle: 'Menu',
    tabs: {
      details: 'Details',
    },
    showMapping: 'Show mapping',
    channel: 'Channel',
    solution: 'Solution',
    dynamicMenu: 'Dynamic menu',
    MOBILE: 'Mobile',
    WEB: 'Web',
    WHATSAPP: 'WhatsApp',
    USSD: 'USSD',
    MIDDLEWARE: 'Middleware',
    OTHER: 'Other',
    loadChildrenError: 'Error loading subitems',
    loading: 'Loading...',
  },
  create: {
    title: 'Create new menu',
    childTitle: 'Add new child',
    addChild: 'Add child',
  },
  edit: {
    title: 'Edit menu',
    titleItem: 'Edit item',
  },
  delete: {
    attention: 'Attention',
    title: 'Delete menu',
    alert: 'Please confirm that you want to delete this menu',
    alertItem: 'Please confirm that you want to delete this menu item',
    success: 'Menu deleted successfully',
    successItem: 'Menu item deleted successfully',
  },
  copy: {
    title: 'Copy menu',
    attention: 'Attention',
    copy: 'Copy menu',
    confirmAlert:
      'Please confirm that you want to copy current menu, after that you will be redirected to the details page of the new menu',
    warningAlert:
      'Please note that this action will copy current menu and all the subitems. You will be redirected to the details page of the new menu after that.',
    error: 'There was an error copying the menu please try again later',
  },
  fields: {
    id: 'ID',
    name: 'Name',
    code: 'Code',
    created: 'Created at',
    priorityIndex: 'Priority index',
    description: 'Description',
    serviceId: 'Service ID',
    actionId: 'Action ID',
    codeValidation: 'Only uppercase letters, numbers and underscores (_) are allowed',
    idValidation: 'Only letters, numbers, hyphens (-), and underscores (_) are allowed.',
    dynamicMenu: 'Dynamic menu',
    parent: 'Parent',
    itemType: 'Item type',
    GROUP: 'Group',
    SERVICE: 'Service',
    ACTION: 'Action',
    addChild: 'Add child',
    fallbackDescription: 'Fallback description',
    fallbackName: 'Fallback name',
    add: 'Add',
    addMapping: 'Add new mapping',
    editMapping: 'Edit mapping',
    deleteMapping: 'Delete mapping',
    channel: 'Channel',
    solution: 'Solution',
    itemDetails: 'Item details',
    status: 'Status',
  },
  channels: {
    MOBILE: 'Mobile',
    WEB: 'Web',
    WHATSAPP: 'WhatsApp',
    USSD: 'USSD',
    MIDDLEWARE: 'Middleware',
    OTHER: 'Other',
  },
};
